<template>
	<div class="wrapper">
		加载中...
	</div>
</template>
<script>
	export default {
		data() {
			return {
				flag: false,
				dec: '',
				srcDec: require('../assets/success.png'),
			}
		},
		computed: {
			// 监听是否加载
			loading() {
				return this.$store.state.loading
			}
		},
		created() {
			// window.alert('老弟，来了' + this.loading)
			if (!this.loading) { // 如果加载过了,直接关闭当前页面,不然回退不了
				// 关闭当前页面
				// window.alert('加载过了，直接关闭')
				// window.alert(window.history.length)
				// window.alert(JSON.stringify(window.history))
				if (window.history.length > 2) { // 发现最少是2 
					window.history.go(-1);
				} else {
					// window.alert('能不能关闭啊')
					// 判断是不是PC
					if (this.isPc()) {
						// window.alert('是PC啊')
						window.close()
					} else {
						//判断谷歌火狐安卓和linux关闭当前页面及浏览器
						var userAgent = navigator.userAgent;
						if (userAgent.indexOf('Android') > -1 || userAgent.indexOf('Linux') > -1) {
							WeixinJSBridge.call('closeWindow');
						} else {
							//针对苹果不能关闭当前页面
							setTimeout(function() {
								WeixinJSBridge.invoke("closeWindow", {}, function(e) {})
							}, 100)
						}
					}
				}
			} else {
				// 修改为加载了
				this.$store.state.loading = false;

				const tp = this.getUrlParam('tp');
				const key = this.getUrlParam('k');
				//四网视频
				if (tp == 1 || tp == 3 || tp == 4) {
					this.$router.replace({
						path: '/home',
						query: {
							key: key
						}
					})
				}
				//油卡
				if (tp == 2) {
					this.$router.replace({
						path: '/oilCost',
						query: {
							key: key
						}
					})
				}
				//话费充值
				if (tp == 5) {
					this.$router.replace({
						path: '/phoneCost',
						query: {
							key: key
						}
					})
				}
				//奈雪的茶/网易云音乐/星爸爸
				if (tp == 7 || tp == 6 || tp == 9) {
					this.$router.replace({
						path: '/kami',
						query: {
							key: key
						}
					})
				}
				if (tp == 8) {
					this.$router.replace({
						path: '/index',
						query: {
							key: key
						}
					})
				}
				if (tp == 11) {
					this.$router.replace({
						path: '/commonIndex',
						query: {
							key: key
						}
					})
				}
				if (tp == 10) {
					this.$router.replace({
						path: '/xianfengsg',
						query: {
							key: key
						}
					})
				}
				if (tp == 13) {
					this.$router.replace({
						path: '/manyType',
						query: {
							key: key
						}
					})
				}
				if (tp == 14) {
					this.$router.replace({
						path: '/wangyi',
						query: {
							key: key
						}
					})
				}
				if (tp == 15) {
					this.$router.replace({
						path: '/moshoushijie',
						query: {
							key: key
						}
					})
				}
				if (tp == 'dt') {
					this.$router.replace({
						path: '/newOilCost',
						query: {
							key: key
						}
					})
				}
			}
		},
		methods: {
			isPc() { // 是否是PC，是PC返回true，不是手机之内的返回false
				let userAgentInfo = navigator.userAgent;
				let Agents = ["Android", "iPhone",
					"SymbianOS", "Windows Phone",
					"iPad", "iPod"
				];
				let flag = true;
				for (let v = 0; v < Agents.length; v++) {
					if (userAgentInfo.indexOf(Agents[v]) > 0) {
						flag = false;
						break;
					}
				}
				return flag;
			},
			getUrlParam(name) {
				let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
				let r = window.location.hash.split('?')[1].substr(0).match(reg); //匹配目标参数
				if (r != null) return decodeURI(r[2]);
				return null; //返回参数值
			}
		}
	}
</script>
<style lang="scss" scoped>
	.wrapper {
		display: flex;
		height: 100%;
		justify-content: center;
		align-items: center;
		font-size: 16px;
	}

	.result {
		position: absolute;
		width: 100%;
		height: 100%;
		left: 0;
		top: 0;
		display: flex;
		justify-content: center;
		align-items: center;

		.dec {
			min-width: 120px;
			height: 120px;
			background: rgba(58, 58, 58, 0.9);
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
			border-radius: 2px;
			padding: 0 10px;

			img {
				width: 36px;
				height: 36px;
				font-size: 14px;
			}

			p {
				font-size: 14px;
				color: #fff;
				padding-top: 8px;
			}
		}
	}
</style>
